import React from "react";
import { Box, Button,  Stack, Tooltip } from "@mui/material";
import MyLabel from "../../../components/myLabel";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTheme } from "@emotion/react";

import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import QrCodeIcon from '@mui/icons-material/QrCode';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import ChecklistIcon from '@mui/icons-material/Checklist';
import DomainVerificationIcon from '@mui/icons-material/DomainVerification';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const trataTipoPergunta = (tipo) => {
    if (tipo === 1){
        return (
            <Tooltip title="Condicional (Sim ou Não)" placement="bottom" arrow>
                <DomainVerificationIcon/>
            </Tooltip>
        )
    }
    else if (tipo === 2){
        return (
            <Tooltip title="Lista escolha" placement="bottom" arrow>
                <ChecklistIcon/>
            </Tooltip>
        )
    }
    else if (tipo === 3){
        return (
            <Tooltip title="Foto" placement="bottom" arrow>
                <CameraAltIcon/>
            </Tooltip>
        )
    }
    else if (tipo === 4){
        return (
            <Tooltip title="Assinatura" placement="bottom" arrow>
                <BorderColorIcon/>
            </Tooltip>
        )
    }
    else if (tipo === 5){
        return (
            <Tooltip title="QRCode" placement="bottom" arrow>
                <QrCodeIcon/>
            </Tooltip>
        )
    }
    else if (tipo === 6){
        return (
            <Tooltip title="Data" placement="bottom" arrow>
                <CalendarMonthIcon/>
            </Tooltip>
        )
    }

    return (
        <Tooltip title="Texto" placement="bottom" arrow>
            <FormatAlignJustifyIcon/>
        </Tooltip>
    )
}

const PerguntaArea = ({templateSecao, templatePerguntas, templatePergunta, modal, dialog, modalConfig}) => {

    const theme = useTheme();

    const handlerLine = (row)=>{
        if (templatePergunta.value && templatePergunta.value.id && templatePergunta.value.id === row.id){
            templatePergunta.set(null)    
        }
        else{
            templatePergunta.set(row)
        }
    
    }   
    
    const dragEnded = (param) => {
        const { source, destination } = param;
        let _arr = [...templatePerguntas.value];
        //extracting the source item from the list
        const _item = _arr.splice(source.index, 1)[0];
        //inserting it at the destination index.
        _arr.splice(destination.index, 0, _item);
        let cont = 0
        _arr = _arr.map(item=>{
            cont +=1
            return {
            ...item, ordem:cont}
                
        })
        templatePerguntas.set(_arr);
      };
    return (
        <Stack spacing={1}>
            <Box sx={{display:'flex', justifyContent:'space-between'}}>
                <MyLabel sx={{ fontSize: "15pt", fontWeight: 600, color: theme.palette.primary.main}} component='h1' text={'Perguntas'}/>
                <Box>
                    <Tooltip title={`Adicionar Pergunta`} placement="left" arrow>
                        <Button onClick={()=>{
                            templatePergunta.set({templatesecao:templateSecao?.id, descricao:'', ordem:templatePerguntas.value.length+1})
                            modal()
                        }}><AddCircleOutlineIcon /></Button>
                    </Tooltip>
                </Box>
            </Box>
            <Box>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
                        <TableHead sx={{backgroundColor: theme.palette.primary.main, color:'#FFF'}}>
                            <TableRow>
                            <TableCell sx={{color:'#FFF'}} > </TableCell>

                               {/* <TableCell sx={{color:'#FFF'}} >ID</TableCell>*/}
                                <TableCell sx={{color:'#FFF'}} >Descrição</TableCell>
                                <TableCell sx={{color:'#FFF'}} >Tipo</TableCell>                                
                                <TableCell sx={{color:'#FFF'}} >Pagina</TableCell>                            
                                <TableCell sx={{color:'#FFF'}} >Visível</TableCell>                            
                                <TableCell sx={{color:'#FFF'}} >Obrigatório</TableCell>                            
                                <TableCell align="right" sx={{color:'#FFF'}}></TableCell>
                            </TableRow>
                        </TableHead>


                        <DragDropContext onDragEnd={dragEnded}>
                            <Droppable droppableId="perguntas">
                                {
                                    (provided) => (
                                        <TableBody ref={provided.innerRef} {...provided.droppableProps}>
                                        {
                                            templatePerguntas.value.sort((a, b) => a.ordem - b.ordem).map((row, index) => {
                                                    return (
                                                        <Draggable
                                                        draggableId={`pergunta-${row.id}`}
                                                        index={index}
                                                        key={row.id}
                                                        >
                                                            {
                                                                (_provided, _snapshot) =>(
                                                                    <TableRow
                                                                    ref={_provided.innerRef} {..._provided.draggableProps} {..._provided.dragHandleProps} 
                                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: templatePergunta.value && templatePergunta.value.id && templatePergunta.value.id === row.id ? theme.palette.secondary.main : 'white'}}>
                                                                    <TableCell {..._provided.dragHandleProps} component="th" scope="row"
                                                                        isDragging={_snapshot.isDragging}
                                                                    >
                                                                        <DragIndicatorIcon />
                                                                    </TableCell>
                                                                    {/*

                                                                    <TableCell onClick={()=>handlerLine(row)} component="th" scope="row">
                                                                        {row.id}
                                                                    </TableCell>
                                                                    */
                                                                    }
                                                                    <TableCell onClick={()=>handlerLine(row)} >{row.descricao}</TableCell>
                                                                    <TableCell onClick={()=>handlerLine(row)} >{trataTipoPergunta(row.tipo_resposta)}</TableCell>                                                                    
                                                                    <TableCell onClick={()=>handlerLine(row)} >{row.pagina}</TableCell>
                                                                    
                                                                    <TableCell>
                                                                        <Tooltip title="Pergunta Visível" placement="bottom" arrow>
                                                                            {
                                                                                row.visivel ? <CheckCircleOutlinedIcon /> : <RadioButtonUncheckedOutlinedIcon/>
                                                                            }
                                                                        </Tooltip>

                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <Tooltip title="Pergunta Obrigatória" placement="bottom" arrow>
                                                                            {
                                                                                row.obrigatorio ? <CheckCircleOutlinedIcon /> : <RadioButtonUncheckedOutlinedIcon/>
                                                                            }
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                    <TableCell align="right" sx={{width:'190px'}}>
                                                                            <Tooltip title={`Configura Condição para estar visível ${row.condicao_visivel ? '(CONFIGURADO!)' : ''}`}  placement="bottom" arrow>
                                                                                    <Button color= {row.condicao_visivel !== '[]' && row.condicao_visivel  ? 'warning' : 'primary' } onClick={()=>{ 
                                                                                            templatePergunta.set(row)                                                
                                                                                            modalConfig()
                                                                                        }} sx={{width:'40px', padding: 0,minWidth:0}}><SettingsApplicationsIcon /></Button>
                                                                            </Tooltip>
                                                                            <Tooltip title="Apagar" placement="bottom" arrow>
                                                                                    <Button color='error' onClick={()=>{
                                                                                            templatePergunta.set(row)
                                                                                            dialog()
                                                                                        }} sx={{width:'40px', padding: 0,minWidth:0}}><DeleteIcon /></Button>
                                                                            </Tooltip>
                                                                            <Tooltip title="Editar" placement="bottom" arrow>
                                                                                    <Button onClick={()=>{
                                                                                        templatePergunta.set(row)
                                                                                        modal()
                                                                                    }} sx={{width:'40px', padding: 0,minWidth:0}}><EditIcon /></Button>
                                                                            </Tooltip>
                                                                    </TableCell>
                                                                </TableRow>
                                                                )
                                                            }

                                                        </Draggable> 
                                                    )
                                            })
                                        }
                                        {provided.placeholder}
                                        </TableBody>

                                    )
                                }
                            </Droppable>
                        </DragDropContext>
                    </Table>
                </TableContainer>
            </Box>
        </Stack>

    )
}
export default PerguntaArea